/**
 * @module module/cluster-page-sk
 * @description <h2><code>cluster-page-sk</code></h2>
 *
 *   The top level element for clustering traces.
 *
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ClusterPageSk", {
    enumerable: true,
    get: function() {
        return ClusterPageSk;
    }
});
const _lit = require("lit");
const _decorators = require("lit/decorators.js");
const _query = require("../../../infra-sk/modules/query");
const _jsonOrThrow = require("../../../infra-sk/modules/jsonOrThrow");
const _stateReflector = require("../../../infra-sk/modules/stateReflector");
const _errorMessage = require("../errorMessage");
const _telemetry = require("../telemetry/telemetry");
require("../../../elements-sk/modules/spinner-sk");
require("../../../elements-sk/modules/checkbox-sk");
require("../../../infra-sk/modules/paramset-sk");
require("../../../infra-sk/modules/sort-sk");
require("../../../infra-sk/modules/query-sk");
require("../algo-select-sk");
require("../cluster-summary2-sk");
require("../commit-detail-picker-sk");
require("../day-range-sk");
require("../query-count-sk");
const _json = require("../json");
const _progress = require("../progress/progress");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
// The state that gets reflected to the URL.
let State = class State {
    constructor(){
        this.begin = Math.floor(Date.now() / 1000 - 24 * 60 * 60);
        this.end = Math.floor(Date.now() / 1000);
        this.offset = -1;
        this.radius = window.perf.radius;
        this.query = '';
        this.k = 0;
        this.algo = 'kmeans';
        this.interesting = window.perf.interesting;
        this.sparse = false;
        if (window.perf.demo) {
            this.begin = Math.floor(new Date(2020, 4, 1).valueOf() / 1000);
            this.end = Math.floor(new Date(2020, 5, 1).valueOf() / 1000);
        }
    }
};
let ClusterPageSk = class ClusterPageSk extends _lit.LitElement {
    createRenderRoot() {
        return this;
    }
    render() {
        return (0, _lit.html)`
      <h2>Commit</h2>
      <commit-detail-picker-sk
        @commit-selected=${this.commitSelected}
        .selection=${this.state.offset}
        id="commit"></commit-detail-picker-sk>

      <h2>Algorithm</h2>
      <algo-select-sk algo=${this.state.algo} @algo-change=${this.algoChange}></algo-select-sk>

      <h2>Query</h2>
      <div class="query-action">
        <query-sk
          @query-change=${this.queryChanged}
          .key_order=${window.perf.key_order}
          .paramset=${this.paramset}
          current_query=${this.state.query}></query-sk>
        <div id="selections">
          <h3>Selections</h3>
          <paramset-sk
            id="summary"
            removable_values
            @paramset-value-remove-click=${this.paramsetRemoveClick}
            .paramsets=${[
            (0, _query.toParamSet)(this.state.query)
        ]}></paramset-sk>
          <div>
            Matches:
            <query-count-sk
              url="/_/count"
              current_query=${this.state.query}
              @paramset-changed=${this.paramsetChanged}></query-count-sk>
          </div>
          <button
            @click=${this.start}
            class="action"
            id="start"
            ?disabled=${!!this.requestId || this.state.offset === -1}>
            Run
          </button>
          <div>
            <spinner-sk id="run-spinner"></spinner-sk>
            <span>${this.status}</span>
          </div>
        </div>
      </div>

      <details>
        <summary id="advanced">Advanced</summary>
        <div id="inputs">
          <label for="k_input">
            K (A value of 0 means the server chooses).
            <input id="k_input" .value=${this.state.k.toString()} @input=${this.kChange} />
          </label>
          <label for="radius_input">
            Number of commits to include on either side.
            <input
              id="radius_input"
              .value=${this.state.radius.toString()}
              @input=${this.radiusChange} />
          </label>
          <label for="interesting_input">
            Clusters are interesting if regression score &gt;= this.
            <input
              id="interesting_input"
              .value=${this.state.interesting.toString()}
              @input=${this.interestingChange} />
          </label>
          <checkbox-sk
            ?checked=${this.state.sparse}
            label="Data is sparse, so only include commits that have data."
            @input=${this.sparseChange}></checkbox-sk>
        </div>
      </details>

      <h2>Results</h2>
      <pre class="messages">${this.runningStatus}</pre>
      <sort-sk target="clusters">
        <button data-key="clustersize">Cluster Size</button>
        <button data-key="stepregression" data-default="up">Regression</button>
        <button data-key="stepsize">Step Size</button>
        <button data-key="steplse">Least Squares</button>
      </sort-sk>
      <div id="clusters" @open-keys=${this.openKeys}>${this._summaryRows()}</div>
    `;
    }
    _summaryRows() {
        const ret = this.summaries.map((summary)=>(0, _lit.html)`
        <cluster-summary2-sk .full_summary=${summary} notriage></cluster-summary2-sk>
      `);
        if (!ret.length) {
            ret.push((0, _lit.html)`<p class="info">No clusters found.</p>`);
        }
        return ret;
    }
    connectedCallback() {
        super.connectedCallback();
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        fetch(`/_/initpage/?tz=${tz}`).then(_jsonOrThrow.jsonOrThrow).then((json)=>{
            this.paramset = (0, _json.ParamSet)(json.dataframe.paramset);
        }).catch(_errorMessage.errorMessage);
        this.stateHasChanged = (0, _stateReflector.stateReflector)(()=>this.state, (newState)=>{
            this.state = newState;
        });
    }
    algoChange(e) {
        this.state = _object_spread_props(_object_spread({}, this.state), {
            algo: e.detail.algo
        });
        this.stateHasChanged();
    }
    kChange(e) {
        this.state = _object_spread_props(_object_spread({}, this.state), {
            k: +e.target.value
        });
        this.stateHasChanged();
    }
    radiusChange(e) {
        this.state = _object_spread_props(_object_spread({}, this.state), {
            radius: +e.target.value
        });
        this.stateHasChanged();
    }
    interestingChange(e) {
        this.state = _object_spread_props(_object_spread({}, this.state), {
            interesting: +e.target.value
        });
        this.stateHasChanged();
    }
    sparseChange(e) {
        this.state = _object_spread_props(_object_spread({}, this.state), {
            sparse: e.target.checked
        });
        this.stateHasChanged();
    }
    queryChanged(e) {
        this.state = _object_spread_props(_object_spread({}, this.state), {
            query: e.detail.q
        });
        this.stateHasChanged();
    }
    paramsetChanged(e) {
        this.paramset = e.detail;
    }
    paramsetRemoveClick(e) {
        const paramset = (0, _query.toParamSet)(this.state.query);
        const values = paramset[e.detail.key] || [];
        const index = values.indexOf(e.detail.value);
        if (index > -1) {
            values.splice(index, 1);
            if (values.length === 0) {
                delete paramset[e.detail.key];
            }
        }
        this.state = _object_spread_props(_object_spread({}, this.state), {
            query: (0, _query.fromParamSet)(paramset)
        });
        this.stateHasChanged();
    }
    openKeys(e) {
        const queryObj = {
            keys: e.detail.shortcut,
            begin: e.detail.begin,
            end: e.detail.end,
            xbaroffset: e.detail.xbar.offset,
            num_commits: 50,
            request_type: 1
        };
        window.open(`/e/?${(0, _query.fromObject)(queryObj)}`, '_blank');
    }
    commitSelected(e) {
        this.state = _object_spread_props(_object_spread({}, this.state), {
            offset: e.detail.commit.offset
        });
        this.stateHasChanged();
    }
    catch(msg) {
        this.requestId = '';
        this.status = '';
        if (msg) {
            (0, _errorMessage.errorMessage)(msg);
        }
    }
    createRegressionDetectionRequest() {
        return {
            step: 0,
            total_queries: 0,
            alert: {
                id_as_string: '-1',
                display_name: '',
                radius: +this.state.radius,
                query: this.state.query,
                k: +this.state.k,
                algo: this.state.algo,
                interesting: +this.state.interesting,
                issue_tracker_component: (0, _json.SerializesToString)(''),
                sparse: this.state.sparse,
                step: '',
                alert: '',
                bug_uri_template: '',
                state: 'ACTIVE',
                owner: '',
                step_up_only: false,
                direction: 'BOTH',
                group_by: '',
                minimum_num: 0,
                category: '',
                action: 'noaction'
            },
            domain: {
                offset: +this.state.offset,
                n: 0,
                end: new Date().toISOString()
            }
        };
    }
    processConfirmedRegressionResults(confirmedRegression) {
        if (!confirmedRegression) {
            return [];
        }
        if (!confirmedRegression.summary || !confirmedRegression.summary.Clusters || !confirmedRegression.frame) {
            (0, _errorMessage.errorMessage)('Received invalid ConfirmedRegression payload: missing summary, Clusters, or frame.', 0, {
                countMetricSource: _telemetry.CountMetric.ConfirmedRegressionInvalidPayload,
                source: 'cluster-page'
            });
            return [];
        }
        const frame = confirmedRegression.frame;
        const summaries = [];
        confirmedRegression.summary.Clusters.forEach((clusterSummary)=>{
            if (clusterSummary) {
                summaries.push({
                    summary: clusterSummary,
                    frame,
                    triage: {
                        status: '',
                        message: ''
                    }
                });
            }
        });
        return summaries;
    }
    async start() {
        if (this.requestId) {
            (0, _errorMessage.errorMessage)('There is a pending query already running.');
            return;
        }
        const body = this.createRegressionDetectionRequest();
        this.summaries = [];
        this.requestId = 'pending';
        this.runningStatus = '';
        try {
            const prog = await (0, _progress.startRequest)('/_/cluster/start', body, {
                pollingIntervalMs: 300,
                onProgressUpdate: (p)=>{
                    this.runningStatus = p.messages.map((msg)=>`${msg.key}: ${msg.value}`).join('\n');
                },
                onStart: ()=>{
                    this.spinner.active = true;
                },
                onSettled: ()=>{
                    this.spinner.active = false;
                }
            });
            if (prog.status === 'Error') {
                throw new Error((0, _progress.messagesToErrorString)(prog.messages));
            }
            this.summaries = this.processConfirmedRegressionResults(prog.results);
        } catch (error) {
            this.catch(error);
        } finally{
            this.requestId = '';
        }
    }
    constructor(...args){
        super(...args);
        // The state to be reflected to the URL.
        this.state = new State();
        this.paramset = (0, _json.ParamSet)({});
        // The computed clusters.
        this.summaries = [];
        // The commits to choose from.
        this.cids = [];
        // The id of the current cluster request. Will be the empty string if
        // there is no pending request.
        this.requestId = '';
        // The status of a running request.
        this.status = '';
        // The text status of the currently running request.
        this.runningStatus = '';
        // Call this anytime something in private state is changed. Will be replaced
        // with the real function once stateReflector has been setup.
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.stateHasChanged = ()=>{};
    }
};
_ts_decorate([
    (0, _decorators.state)()
], ClusterPageSk.prototype, "state", void 0);
_ts_decorate([
    (0, _decorators.state)()
], ClusterPageSk.prototype, "paramset", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Array)
], ClusterPageSk.prototype, "summaries", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", String)
], ClusterPageSk.prototype, "requestId", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", String)
], ClusterPageSk.prototype, "status", void 0);
_ts_decorate([
    (0, _decorators.query)('#run-spinner'),
    _ts_metadata("design:type", Object)
], ClusterPageSk.prototype, "spinner", void 0);
_ts_decorate([
    (0, _decorators.state)()
], ClusterPageSk.prototype, "runningStatus", void 0);
ClusterPageSk = _ts_decorate([
    (0, _decorators.customElement)('cluster-page-sk')
], ClusterPageSk);
